module.exports = __webpack_public_path__ + "img/common-popup.45e76101.png";